import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ChannelNotificationRepositoryService extends BaseRepositoryService<
  ModelRegistry['channel-notification']
> {
  recordName = 'channel-notification';
  implementMethods = ['findRecord', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/channel-notification': ChannelNotificationRepositoryService;
  }
}
